// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const originalTokkoApi = createApi({
  reducerPath: 'originalTokkoApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://tokkobroker.com/api/v1/' }),
  endpoints: () => ({}),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
